import { Navigate, useParams } from 'react-router-dom';
import DynamicPage from '@/components/DynamicPage';
import { getCanonicalPageRedirect, getServiceUrl } from '@/services/searchUrls';

/**
 * `/servicos/detalhes/:slug` → `/servicos/:slug`.
 * `<Navigate to="/servicos/:slug">` does not interpolate params, so read them explicitly.
 */
export const LegacyServiceRedirect = () => {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={getServiceUrl(slug)} replace />;
};

/**
 * `/pages/:slug` renders the generic DynamicPage, unless the slug has a
 * dedicated route (e.g. `/pages/contactos` → `/contactos`), in which case it
 * redirects so old links and indexed URLs land on the canonical page.
 */
export const PageSlugRoute = () => {
  const { slug } = useParams<{ slug: string }>();
  const canonical = getCanonicalPageRedirect(slug);
  return canonical ? <Navigate to={canonical} replace /> : <DynamicPage />;
};
